import axios from "axios";
import axiosRetry from "axios-retry";

const defaultRetryConfig = {
  retries: 5,
  initialDelayMs: 100,
};

export default class HttpClient {
  constructor(baseURL, getCsrfToken, address, config = defaultRetryConfig) {
    this.getCsrfToken = getCsrfToken;
    this.address = address;
    this.client = axios.create({
      baseURL: baseURL,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });
    axiosRetry(this.client, {
      retries: config.retries,
      retryDelay: (retry) => {
        const delay = Math.pow(2, retry) * config.initialDelayMs;
        const jitter = delay * 0.1 * Math.random();
        return delay + jitter;
      },
      retryCondition: (err) =>
        axiosRetry.isNetworkOrIdempotentRequestError(err) ||
        err.response.status === 429,
    });
  }

  async fetch(url, options = {}) {
    const { body, method, headers, params, skipUnauthorizedEvent } = options;

    // 조건부로 address를 params에 추가
    // const req = {
    //   url,
    //   method,
    //   headers: {
    //     ...headers,
    //     "eduseed-csrf-token": this.getCsrfToken(),
    //   },
    //   data: body,
    //   ...(Object.keys(params).length > 0 || this.address
    //     ? {
    //         params: {
    //           ...params,
    //           ...(this.address ? { address: this.address } : {}),
    //         },
    //       }
    //     : {}),
    // };

    const req = {
      url,
      method,
      headers: {
        ...headers,
        "eduseed-csrf-token": this.getCsrfToken(),
      },
      data: body,
      params: {
        ...params,
        address: this.address,
      },
    };

    // const req = {
    //   url,
    //   method,
    //   headers: {
    //     ...headers,
    //     "eduseed-csrf-token": this.getCsrfToken(),
    //   },
    //   data: body,
    // };

    try {
      const res = await this.client(req);
      return res.data;
    } catch (err) {
      console.log("err.response", err);

      if (err.response) {
        const status = err.response.status;
        const data = err.response.data;

        if (status === 429) {
          const rateLimitMessage =
            data?.error ||
            data?.message ||
            "요청이 너무 많습니다. 잠시 후 다시 시도해 주세요.";
          console.error("Rate limit exceeded:", rateLimitMessage);

          const rateErr = new Error(rateLimitMessage);
          rateErr.status = status;
          if (data?.error) rateErr.errorCode = data.error;
          throw rateErr;
        }

        const message =
          data && data.message
            ? data.message
            : `Something went wrong! ${JSON.stringify(err.message)}`;

        // 401 Unauthorized 처리 (SSO 등 세션과 무관한 401은 skipUnauthorizedEvent 로 생략)
        if (status === 401 && !skipUnauthorizedEvent) {
          console.log("Unauthorized access - handling 401 error");
          window.dispatchEvent(new Event("unauthorized"));
        }

        const apiError = new Error(message);
        apiError.status = status;
        if (data?.error) apiError.errorCode = data.error;
        throw apiError;
      }
      throw new Error("connection error");
    }
  }
}
